import {Subscription} from 'rxjs';
import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {filter, map} from 'rxjs/operators';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {Title} from '@angular/platform-browser';
import {Store} from '@ngxs/store';
import {BlogState} from '../state/blog.state';
import {LoadEntry} from '../state/blog.actions';
import {FADE_IN} from '../../../shared/animations';
import { GeneralHeaderComponent } from '../../../layout/header/components/general-header/general-header.component';
import { RtLoadingComponent } from '../../../rt-loading/rt-loading/rt-loading.component';
import { ExploreYourBrainComponent } from '../../../shared/components/explore-your-brain/explore-your-brain.component';
import { FooterComponent } from '../../../layout/footer/footer.component';
import { AsyncPipe, DatePipe } from '@angular/common';
import { SafeHtmlPipe } from '../../../shared/pipes/safe-html/safe-html.pipe';

@Component({
    selector: 'app-blog-entry',
    templateUrl: './blog-entry.component.html',
    styleUrls: ['./blog-entry.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [FADE_IN],
    imports: [GeneralHeaderComponent, RouterLink, RtLoadingComponent, ExploreYourBrainComponent, FooterComponent, AsyncPipe, DatePipe, SafeHtmlPipe]
})
export class BlogEntryComponent implements OnInit, OnDestroy {
  public readonly page$ = this.store.select(BlogState.page);
  public readonly loading$ = this.store.select(BlogState.loading);
  public readonly loadingBody$ = this.store.select(BlogState.loadingBody);

  private subscription = new Subscription();

  /** Link to the main site. */
  private readonly productionUrl = 'https://www.brainkey.ai/';

  constructor(private store: Store, private route: ActivatedRoute, private title: Title) {}

  ngOnInit() {
    this.subscription = this.route.params
      .pipe(
        map(x => x.slug),
        filter(x => !!x)
      )
      .subscribe(slug => this.store.dispatch(new LoadEntry(slug)));
    this.page$.pipe(filter(page => !!page)).subscribe(page => {
      this.title.setTitle(`${page.title} | Blog | BrainKey`);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Share the blog post on Facebook.
   */
  public shareOnFacebook(title: string): void {
    const urlToShare = encodeURIComponent(this.productionUrl);
    const quoteToShare = encodeURIComponent(title);

    window.open(`https://www.facebook.com/sharer/sharer.php?u=${urlToShare}&quote=${quoteToShare}`, '_blank');
  }

  /**
   * Share the blog post on X.
   */
  public shareOnX(title: string): void {
    const urlToShare = encodeURIComponent(this.productionUrl);
    const textToShare = encodeURIComponent(title);

    window.open(`https://x.com/intent/tweet?url=${urlToShare}&text=${textToShare}`, '_blank');
  }

  /**
   * Share the blog post on LinkedIn.
   */
  public shareOnLinkedIn(title: string): void {
    const urlToShare = encodeURIComponent(this.productionUrl);
    const titleToShare = encodeURIComponent(title);
    const summaryToShare = encodeURIComponent(title);
    const sourceToShare = encodeURIComponent('BrainKey Blog');

    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${urlToShare}&title=${titleToShare}&summary=${summaryToShare}&source=${sourceToShare}`,
      '_blank'
    );
  }
}
